import React from 'react';
import { defaultLocale } from '../../utils';

const LocaleContext = React.createContext({
  locale: defaultLocale,
  translations: {},
});

export default LocaleContext;
